import {WORKOUT_WARNINGS} from '../constants/OtherMessages';

export function isWorkoutValid(
  workoutEntryDate,
  miles,
  steps,
  hours,
  minutes,
  seconds,
) {
  let workoutEntryDate_error = '';
  let miles_error = '';
  let steps_error = '';
  let time_error = '';

  const duration = (
    parseInt(hours || 0) * 60 +
    parseInt(minutes || 0) +
    parseInt(seconds || 0) / 60
  ).toString();

  const required_field = 'THIS FIELD IS REQUIRED';
  const number_required = 'PLEASE ENTER A NUMBER';

  if (!workoutEntryDate) {
    workoutEntryDate_error = required_field;
  }

  if (isNaN(miles)) {
    miles_error = number_required;
  }

  if (miles && miles.length > 7) {
    miles_error = WORKOUT_WARNINGS.milesDigit;
  }

  if (miles && parseFloat(miles) > 999.99) {
    miles_error = WORKOUT_WARNINGS.milesLength;
  }

  if (miles && miles.includes('.') && miles.split('.')[1].length > 2) {
    miles_error = WORKOUT_WARNINGS.milesDecimals;
  }

  if (isNaN(steps)) {
    steps_error = number_required;
  }

  if (steps && parseInt(steps) > 99999) {
    steps_error = WORKOUT_WARNINGS.stepsLength;
  }

  if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
    time_error = number_required;
  }

  if (duration && parseFloat(duration) > 1440) {
    time_error = WORKOUT_WARNINGS.timeLength;
  }
  return {
    workoutEntryDate_error: workoutEntryDate_error,
    miles_error: miles_error,
    steps_error: steps_error,
    time_error: time_error,
  };
}
